<header *ngIf="notFromDoc && !fromShop && !fromReturns">
    <label class="close_button" (click)="close()">x</label>
    <div class="header" style="display:block">
        <h1> {{heading}} </h1>
    </div>
</header>

<div style="position: relative;">
    <div class="body" *ngIf="notFromDoc && !fromShop && !fromReturns">
        <div style=" max-height: 70px; 
   overflow-y: auto;">
            <span *ngFor="let row of description">
                <label class="catlabel"> {{row.route}}</label>
            </span>
        </div>
    </div>


    <div class="footerp" style="position: relative;top: 14px;" *ngIf="notFromDoc && !fromShop && !fromReturns">
        <span (click)="onNoClick()" class="cancel" style="display: inline; background: transparent;border: none !important;padding-left: 21px;position: relative;
        top: 10px;"> CANCEL </span>
        <button mat-raised-button class="submit submit1" style="display: inline;" (click)="delete()">CONFIRM</button>
    </div>
</div>

<div *ngIf="fromShop && !fromReturns">

    <header>
        <label class="close_button" (click)="close()">x</label>
        <div class="header" style="display:block">
            <h1> {{heading}} </h1>
        </div>
    </header>

    <div style="position: relative;">
        <div class="body">
            <div style=" max-height: 70px; overflow-y: auto;">
                <label class="catlabel"> {{description}}</label>
            </div>
        </div>


        <div class="footerp" style="position: relative;top: 14px;">
            <span (click)="onNoClick()" class="cancel" style="display: inline; background: transparent;border: none !important;padding-left: 21px;position: relative;
            top: 10px;"> CANCEL </span>
            <button mat-raised-button class="submit submit1" style="display: inline;"
                (click)="delete()">CONFIRM</button>
        </div>
    </div>

</div>

<div *ngIf="!notFromDoc && forLink !=='MULTIROUTE' && forLink !== 'MULTILP' && !fromReturns">
    <header>
        <label class="close_button" (click)="close()">x</label>
        <div class="header" style="display:block;text-align: center;">
            <h1> {{heading}} </h1>
        </div>
    </header>
    <div style="position: relative;">
        <div class="body">
            <div class="row">
                <div class="col-2"></div>
                <div class="col-8">
                    <label class="catlabel" style="display:block;text-align: center;margin-bottom: 9%;margin-top:17%">
                        {{description}}</label>
                </div>
                <div class="col-2"></div>
            </div>
        </div>
        <div class="footerp" style="position: relative;top: 32px;">
            <span (click)="onNoClick()" class="cancel" style="display: inline; background: transparent;border: none !important;padding-left: 21px;position: relative;
            top: 10px;"> CANCEL </span>
            <button mat-raised-button class="submit submit1" style="display: inline;"
                (click)="saveClick()">CONFIRM</button>
        </div>
    </div>

</div>

<div *ngIf="!notFromDoc && forLink !=='MULTIROUTE' && forLink == 'MULTILP' && !fromReturns">
    <header *ngIf="forLink == 'MULTILP'">
        <label class="close_button" (click)="close()">x</label>
        <div class="header" style="display:block;text-align: center;">
            <h1> {{heading}} </h1>
        </div>
    </header>
    <div style="position: relative;">
        <div class="body">
            <div *ngIf="forLink == 'MULTILP'">
                <label class="catlabel" style="display:block;text-align: center;">
                    {{description}}</label>
            </div>
        </div>
        <div class="footerp" style="position: relative;top: 43px;">
            <span (click)="onNoClick()" class="cancel" style="display: inline; background: transparent;border: none !important;padding-left: 21px;position: relative;
            top: 10px;"> CANCEL </span>
            <button mat-raised-button class="submit submit1" style="display: inline;"
                (click)="saveClick()">CONFIRM</button>
        </div>
    </div>

</div>

<div *ngIf="!notFromDoc && forLink=='MULTIROUTE' && !fromReturns">
    <header>
        <label class="close_button" (click)="close()">x</label>
        <div class="header" style="display:block;text-align: center;">
            <h1> {{heading}} </h1>
        </div>
    </header>
    <div style="position: relative;">
        <div class="body">
            <div class="row">
                <div class="col-2"></div>
                <div class="col-8">
                    <label class="catlabel" style="display:block;text-align: center;margin-bottom: 8%;margin-top: 8%">
                        {{description}}:
                        <br>
                        <span>
                            <select name="routeTime" id="routeTime" [(ngModel)]="timeSelected"
                                (change)="setRouteValue($event)">
                                <option [ngValue]="" disabled>Select time</option>
                                <option *ngFor="let route of routes" [ngValue]="route">
                                    {{route.connectionTime}}</option>
                            </select>
                        </span></label>

                </div>
                <div class="col-2"></div>
            </div>
        </div>
        <div class="footerp" style="position: relative;top: 34px;">
            <span (click)="onNoClick()" class="cancel" style="display: inline; background: transparent;border: none !important;padding-left: 21px;position: relative;
            top: 10px;"> CANCEL </span>
            <button mat-raised-button class="submit submit1" [disabled]="btndis"
                [ngStyle]="{'cursor': btndis ? 'not-allowed' : 'pointer' }" style="display: inline;"
                (click)="saveClick()">CONFIRM</button>
        </div>
    </div>
</div>

<div *ngIf="fromReturns">
    <header>
        <label class="close_button" (click)="close()">x</label>
        <div class="header" style="display:block;text-align: center;">
            <h1> {{heading}} </h1>
        </div>
    </header>
    <div style="position: relative;">
        <div class="body">
            <div class="row">
                <div class="col-2"></div>
                <div class="col-8">
                    <label class="catlabel" style="display:block;text-align: center;margin-bottom: 8%;margin-top: 8%">
                        {{description}}:
                        <br>
                        <span>
                            <select name="routeTime" id="routeTime" [(ngModel)]="timeSelected"
                                (change)="setRouteValue($event)">
                                <option [ngValue]="" disabled>Select return time</option>
                                <option *ngFor="let route of routes" [ngValue]="route" >
                                   <span *ngIf="type == 'UNLOAD'">{{route.arrdatetime}}</span> <span *ngIf="type == 'RELOAD'">{{route.depdatetime}}</span> </option>
                            </select>
                        </span></label>

                </div>
                <div class="col-2"></div>
            </div>
        </div>
        <div class="footerp" style="position: relative;top: 34px;">
            <span (click)="onNoClick()" class="cancel" style="display: inline; background: transparent;border: none !important;padding-left: 21px;position: relative;
                top: 10px;"> CANCEL </span>
            <button mat-raised-button class="submit submit1" [disabled]="btndis"
                [ngStyle]="{'cursor': btndis ? 'not-allowed' : 'pointer' }" style="display: inline;"
                (click)="saveClick()">CONFIRM</button>
        </div>
    </div>



</div>

